<template>
  <div>
    <span v-if="data.column.field === 'adapterCode'">
      {{ data.row[data.column.field] }}
    </span>
    <span v-else-if="data.column.field === 'averageCPM' || data.column.field === 'maxCPM' || data.column.field === 'minCPM'">
      {{ data.row[data.column.field] | formatCurrency }}
    </span>
    <span v-else-if="data.column.field === 'averageResponseTime'">
      {{ data.row[data.column.field] | formatValue }} ms
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] | formatValue }}
    </span>
  </div>
</template>

<script>
export default {
  filters: {
    formatValue(amount) {
      const amt = Number(amount)
      // eslint-disable-next-line no-mixed-operators
      return amt && amt.toLocaleString(undefined, { maximumFractionDigits: 2 }) || '0'
    },
  },
  props: {
    data: {
      type: [Array, Object],
    },
  },
}
</script>
